import { Box, Typography, Divider, Chip } from '@mui/material';
// Define available MUI chip colors
const chipColors = ["primary", "secondary", "success", "error", "info", "warning"];
function Skills({ skills }) {
    return (
        <Box sx={{ width: '100%', bgcolor: '#fff', boxShadow: 1, borderRadius: 1, p: 2, mb:0.5, display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 2 }}>
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h5" sx={{ color: '#666' }}>Skills</Typography>
                    <Divider sx={{ mb: 0.5 }} />
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {skills && ( skills.slice(0, 15).map((skill, index) => (
                            <Chip key={index} label={skill} color={chipColors[Math.floor(Math.random() * chipColors.length)]} size="small" sx={{ mt: 1, bgcolor: 'rgba(0,0,0,0.08)', color: '#333', fontWeight: 500 }} />
                        )))}
                    </Box>
                </Box>
            </Box>
    )
}

export default Skills;